// This is used by the list.component object to dynamically apply pipes

import { formatCurrency, formatDate, formatPercent } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AddressPipe } from './address.pipe';
import { ArticleStatusPipe } from './article-status.pipe';
import { BadgeStatusDescColorPipe } from './badge-status-desc-color.pipe';
import { DatePipe } from './date.pipe';
import { FormSelectionMethodPipe } from './form-selection-method.pipe';
import { NumberPipe } from './number.pipe';
import { PhonePipe } from './phone.pipe';
import { PhoneNumPipe } from './phonenum.pipe';
import { RoleTypePipe } from './roletype.pipe';
import { ShowLastFourCharactersPipe } from './show-last-four-characters.pipe';

@Pipe({
    name: 'epListPipe',
    standalone: false
})
export class ListPipe implements PipeTransform {
    constructor(
        private phonePipe: PhonePipe,
        private addressPipe: AddressPipe,
        private numberPipe: NumberPipe,
        private datePipe: DatePipe,
        private phoneNumPipe: PhoneNumPipe,
        private roleTypePipe: RoleTypePipe,
        private articleStatusPipe: ArticleStatusPipe,
        private formSelectionMethodPipe: FormSelectionMethodPipe,
        private showLastFourCharactersPipe: ShowLastFourCharactersPipe,
        private badgeStatusDescColorPipe: BadgeStatusDescColorPipe
    ) { }

    transform(value: string, format: string) {
        if (!value || !format) {
            return value;
        }

        let fmt = format.toString().split(':');

        let result = '';
        let locale = 'en-US';
        let digitsInfo = '';

        switch (fmt[0].toLowerCase()) {
            case 'epdate':
                result = this.datePipe.transform(value, fmt[1]);
                break;

            case 'date':
                let dateFormat = fmt[1].replace('.', ':');
                result = formatDate(value, dateFormat, locale);
                break;

            case 'epphone':
                //console.log('phone.value -> ' + value)

                let phoneObj = JSON.parse(value);

                result = this.phonePipe.transform(phoneObj);

                //console.log('phone.result -> ' + result)
                break;

            case 'epphonenum':
                result = this.phoneNumPipe.transform(value);
                break;

            case 'epaddress':
                let addressObj = JSON.parse(value);
                result = this.addressPipe.transform(addressObj);
                break;

            case 'epnumber':
                result = this.numberPipe.transform(value, fmt[1]);
                break;

            case 'eproletype':
                result = this.roleTypePipe.transform(value);
                break;

            case 'eparticlestatus':
                result = this.articleStatusPipe.transform(value);
                break;

            case 'epformselectionmethod':
                result = this.formSelectionMethodPipe.transform(value);
                break;

            case 'epshowlastfourcharacters':
                result = this.showLastFourCharactersPipe.transform(value);
                break;
            case 'epbadgestatusdesccolor':
                result = this.badgeStatusDescColorPipe.transform(value);
                break;

            case 'currency':
                let currencyCode = fmt[1];
                let currency = fmt[2] ? '$' : null;
                digitsInfo = fmt[3] ? fmt[3] : null;

                result = formatCurrency(Number(value), locale, currency, currencyCode, digitsInfo);
                break;

            case 'percent':
                digitsInfo = fmt[1];

                result = formatPercent(Number(value), locale, digitsInfo);
                break;

            case 'lowercase':
                result = value.toLowerCase();
                break;

            case 'uppercase':
                result = value.toUpperCase();
                break;

            case 'mixedcase':
                result = this.toTitleCase(value);
                break;

            default:
                result = value;
        }

        return result;
    }

    toTitleCase(str: string) {
        return str
            .toLowerCase()
            .split(' ')
            .map(function (word) {
                return word.replace(word[0], word[0].toUpperCase());
            })
            .join(' ');
    }
}
